// @flow

import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontBold, fontNormal, defaultSize } from "@fdr/static-ui/Typography";

import ButtonDefault from "../../_atoms/ButtonDefault";
import Tag from "../../_atoms/Tag";

export const RunnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1 1 auto;
  ${({ scratched }) =>
    scratched &&
    css`
      opacity: 0.5;
    `};

  &:active {
    ${(props) =>
      props.showActiveState &&
      `background-color: ${buildColor("grey", "100")}`};
  }

  &:last-child {
    border-bottom: 0 none;
  }
`;

export const RunnerInfo = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const AnyButton = styled(ButtonDefault)`
  width: 100%;
  flex: 1 1 auto;
  border-radius: 0 4px 4px 0;
  ${({ isChecked }) =>
    isChecked
      ? css`
          color: ${buildColor("white", "100")};
          background-color: ${buildColor("blue", "500")};
        `
      : css`
          color: ${buildColor("blue", "500")};
          background-color: ${buildColor("white", "100")};
        `};
  font-size: 14px;
  position: relative;
  height: 40px;
`;

export const JockeySilk = styled.img`
  width: 34px;
  height: 35px;
`;

export const JockeySilkContainer = styled.div`
  ${({ hasTimeformInfo }) =>
    hasTimeformInfo
      ? css`
          align-items: flex-start;
          margin-right: 12px;
          width: 42px;
        `
      : css`
          align-items: center;
          margin-right: 20px;
          margin-left: 8px;
          width: 20px;
        `};
  height: 43px;
  display: flex;
  position: relative;
  align-self: center;
`;

export const RunnerContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const RunnerInfoContainer = styled.dl`
  width: 100%;
  height: 67px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  overflow: hidden;
  padding: 12px;
  padding-left: 0;
  border-radius: 1px;
  border-bottom: ${(props) =>
    props.isNotLastRunner && `1px solid ${buildColor("grey", "300")}`};
`;

export const HorseDescription = styled.dt`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const DriverDescription = styled.dd`
  height: 17px;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-family: ${fontNormal};
  color: ${buildColor("grey", "800")};
`;

export const OddsContainer = styled.dl`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  white-space: nowrap;
  margin-left: 16px;
`;

export const OddInfo = styled.dt`
  display: flex;
  flex-direction: row;
  color: ${buildColor("grey", "900")};
  font-family: ${fontBold};
  font-size: 14px;
  transform: translate(0, -2px);

  & > :nth-child(n) {
    margin-right: 6px;
  }
`;
export const RunnerLineWrapper = styled(Link)`
  height: 67px;
  width: 292px;
  display: flex;
  flex-direction: column;
  padding: 0 0 0 12px;
  text-decoration: none;
`;

export const HorseName = styled.span`
  height: 18px;
  font-size: ${defaultSize};
  line-height: 125%;
  font-family: ${fontBold};
  color: ${buildColor("grey", "900")};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-grow: 1;
  margin-bottom: 4px;
`;

export const ScratchedTag = styled(Tag)`
  margin-right: 12px;
`;
